import { useState, useEffect } from "react";
import { AdminField, AdminSaveButton, AdminSection } from "@/admin/AdminComponents";
import { Plus, Trash2 } from "lucide-react";

const AboutEditor = ({ data, onSave, saving }) => {
  const [form, setForm] = useState({});

  useEffect(() => { setForm({ ...data }); }, [data]);

  const update = (key, val) => setForm((p) => ({ ...p, [key]: val }));
  const updatePart = (idx, key, val) => {
    const parts = [...(form.statement_parts || [])];
    parts[idx] = { ...parts[idx], [key]: val };
    setForm((p) => ({ ...p, statement_parts: parts }));
  };
  const removePart = (idx) => {
    const parts = [...(form.statement_parts || [])];
    parts.splice(idx, 1);
    setForm((p) => ({ ...p, statement_parts: parts }));
  };
  const addPart = () => {
    const parts = [...(form.statement_parts || [])];
    parts.push({ text: "", highlight: false });
    setForm((p) => ({ ...p, statement_parts: parts }));
  };

  return (
    <div data-testid="about-editor">
      <AdminSection title="About Section" description="Edit the company positioning statement">
        <AdminField label="Section Label" value={form.label} onChange={(v) => update("label", v)} />
      </AdminSection>

      <AdminSection title="Statement Parts" description="Each part can be highlighted (white) or muted. Together they form the full statement.">
        {(form.statement_parts || []).map((part, idx) => (
          <div key={idx} className="flex items-start gap-3 p-3 rounded-lg bg-white/[0.02] border border-white/[0.06]">
            <div className="flex-1 space-y-2">
              <AdminField label={`Part ${idx + 1}`} value={part.text} onChange={(v) => updatePart(idx, "text", v)} />
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={part.highlight || false}
                  onChange={(e) => updatePart(idx, "highlight", e.target.checked)}
                  className="w-4 h-4 rounded bg-white/[0.04] border-white/[0.15] accent-white"
                />
                <span className="text-xs text-neutral-400 font-['Manrope']">Highlight (white text)</span>
              </label>
            </div>
            <button onClick={() => removePart(idx)} className="p-1.5 mt-6 rounded-md text-neutral-600 hover:text-red-400 hover:bg-red-500/10 transition-colors">
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </div>
        ))}
        <button
          data-testid="add-statement-part"
          onClick={addPart}
          className="w-full flex items-center justify-center gap-2 py-3 rounded-xl border border-dashed border-white/[0.1] text-sm text-neutral-500 font-['Manrope'] hover:border-white/[0.2] hover:text-white transition-colors duration-200"
        >
          <Plus className="w-4 h-4" /> Add Part
        </button>
      </AdminSection>

      <AdminSection title="Detail Text">
        <AdminField label="Supporting paragraph" value={form.detail} onChange={(v) => update("detail", v)} rows={3} />
      </AdminSection>

      <AdminSaveButton onClick={() => onSave(form)} saving={saving} />
    </div>
  );
};

export default AboutEditor;
